<!-- Zweck: Stellt die HTML-Struktur für app no agb accepted component im Frontend bereit. -->
<div class="errorcontent">
  <div>
    <div class="errorlogobox">
      <img class="logo" src="{{cfg.domainconfig.logofilename}}"/>
    </div>


    <div class="errorbox">
      <h1>Auf Wiedersehen</h1>

      <hr>


      <h4>Leider können Sie ohne Zustimmung nicht fortfahren.</h4>

      <hr>

      <button mat-flat-button routerLink="/" color="primary">
        Zum Dashboard
      </button>
    </div>
  </div>
</div>
